<template>
  <a href="#" class="doc-download-media">
    <div class="doc-download-media__info">
      <span>{{ type }}</span>
      {{ title }}
    </div>
    <BaseIcon v-if="type === 'Watch'" class="doc-download-media__icon" name="visibility" size="24"></BaseIcon>
    <BaseIcon v-else class="doc-download-media__icon" name="description" size="24"></BaseIcon>
  </a>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
export default {
  name: 'CardMedia',
  components: { BaseIcon },
  props: {
    doclink: {
      type: String,
      default: 'document.docx'
    },
    title: {
      type: String,
      default: 'Download Title'
    },
    type: {
      type: String,
      default: 'PDF'
    }
  }
}
</script>

<style lang="postcss">
.doc-download-media {
  @apply border border-l-4 border-body-lighter pl-8 cursor-pointer w-full flex justify-between items-center font-semibold text-base text-body-light no-underline;
}
.doc-download-media:last-of-type {
  @apply border-b;
}
.doc-download-media__info {
  @apply pr-4;
}
.doc-download-media__info span {
  @apply block font-semibold text-xs text-body-light tracking-wide;
}
.doc-download-media__icon {
  @apply bg-primary-lightest border-body-lightest px-6 py-10;
}
.doc-download-media:hover {
  @apply text-secondary;
  border-left-color: #00893f;
}
.doc-download-media:hover .doc-download-media__icon {
  @apply text-secondary;
}
@screen md {
  .doc-download-media {
    @apply text-lg;
  }
}
</style>
